import { PrismButton, PrismCheckbox, PrismDialog } from "@prism-ui/react";
import type { EventDraft } from "./ProjectFairs";

interface AttendeeToolsModalProps {
  show: boolean;
  draft: EventDraft;
  saving: boolean;
  onChange: (updater: (prev: EventDraft) => EventDraft) => void;
  onSave: () => void;
  onCancel: () => void;
}

// Per-event feature switches. The Print button is an officer/admin toolbar control; Join
// Live is public-facing. Public Closing Banner content is configured separately because it
// appears together at the bottom of the public fair page.
const AttendeeToolsModal = ({ show, draft, saving, onChange, onSave, onCancel }: AttendeeToolsModalProps) => (
  <PrismDialog open={show} close-method="user" onPrismClose={onCancel} setAriaLabel="Attendee Tools">
    <span slot="header">Attendee Tools</span>
    <div className="project-fairs-modal-body">
      <section className="project-fairs-tile">
        <h4>Print</h4>
        <p className="project-fairs-field-help">
          Show or hide the Print button in the Project Fair toolbar. This button is available only to officers
          and admins; it is never shown to public attendees.
        </p>
        <PrismCheckbox
          label="Show the print button"
          checked={draft.print_enabled}
          onPrismChange={(e: CustomEvent<{ checked?: boolean }>) =>
            onChange((prev) => ({ ...prev, print_enabled: !!e.detail?.checked }))
          }
        />
      </section>
      <section className="project-fairs-tile">
        <h4>Join Live</h4>
        <p className="project-fairs-field-help">
          Show or hide the Join Live button on project cards for this event. Turn it off for
          in-person events, which share their projects with the virtual fair and would
          otherwise advertise a Teams meeting that doesn't exist. The post-fair "Watch"
          recording link is not affected.
        </p>
        <PrismCheckbox
          label="Show the Join Live button"
          checked={draft.join_live_enabled}
          onPrismChange={(e: CustomEvent<{ checked?: boolean }>) =>
            onChange((prev) => ({ ...prev, join_live_enabled: !!e.detail?.checked }))
          }
        />
      </section>
    </div>
    <PrismButton slot="footer" tone="secondary" display="outline" onPrismClick={onCancel}>
      Cancel
    </PrismButton>
    <PrismButton slot="footer" tone="primary-brand" display="fill" disabled={saving} loading={saving} onPrismClick={onSave}>
      Save
    </PrismButton>
  </PrismDialog>
);

export default AttendeeToolsModal;
